import React from "react";
import ReactDOM from "react-dom";
import { Styles } from "./Styles";
import { DataProvider } from "./DataProvider";
import FeaturedContent from "./components/FeaturedContent";
import Podcast from "./components/Podcasts";
import { insertAfter, waitForElement } from "./utils";
import "./polyfill";
import {
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

function mountStyles(e) {
  const div = document.createElement("div");
  const body = document.getElementsByTagName("body")[0];
  body.appendChild(div);
  ReactDOM.render(
    <React.StrictMode>
      <Styles />
    </React.StrictMode>,
    div
  );
}

async function removeFeaturedTab() {
  const chevronRight = await waitForElement(
    ".live-board-mobile .items-view-container .items-header .category-navigation .icon-chevron-right"
  );

  const navigationTitle = await waitForElement(
    ".live-board-mobile .items-view-container .items-header .category-navigation h1"
  );

  if (navigationTitle.innerText === "Solution") {
    chevronRight.addEventListener("click", function (e) {
      chevronRight.click();
    });
  }
}

async function mountPodcastSection() {
  const podcastsContainer = await waitForElement(
    "div.current-item iframe.ql-video"
  );
  const podcastName = await waitForElement("div.user-info > div.user-name");
  const isSunnySideUpPodcast = podcastName?.innerText === "Sunny Side Up Media";
  if (isSunnySideUpPodcast) {
    const alreadyMountedContainer = document.querySelector(
      "div.podcast-container"
    );
    if (alreadyMountedContainer) {
      return;
    }
    const podcastContainer = document.createElement("div");
    podcastContainer.classList.add("podcast-container");
    ReactDOM.render(
      <React.StrictMode>
        <Podcast />
      </React.StrictMode>,
      podcastContainer
    );
    insertAfter(podcastsContainer, podcastContainer);
  }
}

function featuredContent(e) {
  const itemViewContainer = document.querySelector(".board-content-container");
  if (!itemViewContainer) {
    console.warn(".board-content-container not found in theDOM");
    return;
  }

  const alreadyMountedContainer = document.querySelector(
    "div.feature-content-container"
  );
  if (alreadyMountedContainer) {
    return;
  }

  const featureContentContainer = document.createElement("div");
  featureContentContainer.classList.add("feature-content-container");

  ReactDOM.render(
    <React.StrictMode>
      <DataProvider>
        <FeaturedContent />
      </DataProvider>
    </React.StrictMode>,
    featureContentContainer
  );

  itemViewContainer.insertAdjacentElement(
    "afterbegin",
    featureContentContainer
  );
  // It looks like the following selector returns null, I guess that we can remove the following block
  if (document.querySelector("a[href='/resources/featured---banner']")) {
    document
      .querySelector("a[href='/resources/featured---banner']")
      .closest(".category")
      .remove();
  }
}

function mountSocialMediaIcons(event) {
  // Clean icons if present
  if (document.querySelector(".share-icons"))
    document.querySelector(".share-icons").remove();

  // Check for existing dom element to append social icons
  const itemViewer = document.querySelector(".item-viewer");
  const container = document.querySelector(
    ".item-content-wrapper.current-item"
  );
  const item = event.detail.item;

  if (itemViewer && container) {
    let temp = document.createElement("div");
    temp.style.padding = "10px";
    temp.style.display = "flex";
    temp.style.flexDirection = "column";
    temp.style.position = "fixed";
    temp.style.right = "10px";
    temp.style.background = "white";
    temp.style.top = "calc(50% - 120px)";

    temp.classList.add("share-icons");
    temp.style.padding = "10px";
    temp.style.textAlign = "center";

    ReactDOM.render(
      <React.StrictMode>
        <TwitterShareButton title={item.name} url={window.location.href}>
          <TwitterIcon size={32} round={false} />
        </TwitterShareButton>
        <LinkedinShareButton title={item.name} url={window.location.href}>
          <LinkedinIcon size={32} round={false} />
        </LinkedinShareButton>
      </React.StrictMode>,
      temp
    );

    container.insertAdjacentElement("afterend", temp);
  }
}

if (document.readyState === "complete") {
  mountStyles();
} else {
  window.addEventListener("load", mountStyles);
}

window.addEventListener("Folloze.itemViewerLoaded", () => {
  mountPodcastSection();
});

window.addEventListener("Folloze.itemsContentMounted", featuredContent);
window.addEventListener("Folloze.itemViewerLoaded", mountSocialMediaIcons);

window.addEventListener("Folloze.itemsContentMounted", removeFeaturedTab);

function scrollToItemsViewContainer() {
  let tries = 0;
  const scroll = () => {
    const section = document.querySelector("section.items-view-container");
    const ready = document.readyState === "complete";
    if (section && ready) {
      setTimeout(() => {
        section.scrollIntoView();
      }, 1500);
    } else {
      tries++;
      if (tries < 50) {
        setTimeout(() => {
          scroll();
        }, 500);
      }
    }
  };
  scroll();
}

if (window?.location?.hash === "#content") {
  scrollToItemsViewContainer();
}

function scrollModalBack() {
  const scroll = () => {
    const section = document.querySelector(
      "#item-viewer-modal-placement > div > div"
    );
    const ready = document.readyState === "complete";
    if (ready && section && section.scrollTop > 0) {
      section.scrollTop = 0;
    }
    setTimeout(() => {
      scroll();
    }, 500);
  };
  scroll();
}

scrollModalBack();
